<template>
    <div>
      <invoice-approval-list></invoice-approval-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>